import React, { useState, useEffect, useContext } from 'react'
import {
  CButton,
  CCol,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CRow,
} from '@coreui/react'
import ReactDragListView from 'react-drag-listview/lib/index.js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { getThumbnail, raiseToast } from '../../utils/helper'
import CIcon from '@coreui/icons-react'
import { cilTrash } from '@coreui/icons'
import { GlobalContext } from 'src/views/context/GlobalState'
import ImageNotFound from '../../../assets/image-not-found.jpg'
import { AppContext } from 'src/views/context/app'

const StaticSwimlane = ({
  contentModal,
  addedcotentData,
  updateAddedContent,
  contentPayload,
  setContentPayload,
}) => {
  const [contentArray, setContentArray] = useState([...addedcotentData])
  const { userSessionObj } = useContext(GlobalContext)
  const language = localStorage.getItem('language')
  const { accountObj } = useContext(AppContext)
  const defaultLangCheck = language === accountObj?.default_language

  useEffect(() => {
    setContentArray([...addedcotentData])
  }, [addedcotentData])

  const removeContent = (info) => {
    updateAddedContent(addedcotentData.filter((obj) => obj._id !== info._id))
    setContentPayload(contentPayload.filter((id) => id !== info._id))
  }

  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      if (!defaultLangCheck) {
        raiseToast('error', 'Reordering Allowed only on Default Language')
        return
      }
      const data = [...contentArray]
      const item = data.splice(fromIndex, 1)[0]
      data.splice(toIndex, 0, item)
      setContentArray([...data])
      const payload = [...contentPayload]
      const item2 = payload.splice(fromIndex, 1)[0]
      payload.splice(toIndex, 0, item2)
      setContentPayload([...payload])
    },
    handleSelector: '',
  }
  return (
    <CRow>
      <CCol lg="3">
        <p className="swimlane-options">Add contents to the swimlane</p>
        <CButton
          className="text-white"
          color="info"
          shape="rounded-pill"
          onClick={() => contentModal()}
          disabled={!defaultLangCheck}
          style={{ pointerEvents: 'auto' }}
          title={defaultLangCheck ? '' : 'Adding Content Available on Default Language'}
        >
          <FontAwesomeIcon icon={faPlusCircle} className="mx-1" />
          Add
        </CButton>
      </CCol>

      <CCol lg="9" className="">
        <div className="swimalne-Content-box">
          <ReactDragListView {...dragProps}>
            <CTable style={{ textAlign: 'center' }} striped hover={defaultLangCheck}>
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell>SI. No.</CTableHeaderCell>
                  <CTableHeaderCell>Thumbnail</CTableHeaderCell>
                  <CTableHeaderCell>Title</CTableHeaderCell>
                  <CTableHeaderCell />
                </CTableRow>
              </CTableHead>

              <CTableBody>
                {contentArray.map((info, index) => {
                  return (
                    <CTableRow key={index} style={{ cursor: `${defaultLangCheck ? 'move' : ''}` }}>
                      <CTableDataCell align="middle">{index + 1}</CTableDataCell>
                      <CTableDataCell>
                        <img
                          className="card-img-top"
                          src={getThumbnail(
                            userSessionObj.session_data.cf_domain_name,
                            info?.thumbnail?.website?.s3_key,
                          )}
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null // prevents looping
                            currentTarget.src = ImageNotFound
                          }}
                          alt={info?.title}
                          style={{ width: '10rem', height: '5rem' }}
                        />
                      </CTableDataCell>
                      <CTableDataCell align="middle">{info?.title}</CTableDataCell>
                      <CTableDataCell align="middle">
                        <CIcon
                          icon={cilTrash}
                          style={{ color: 'red', cursor: 'pointer' }}
                          size="xl"
                          title={
                            !defaultLangCheck ? 'Remove Available on Default Language' : 'Remove'
                          }
                          onClick={defaultLangCheck ? () => removeContent(info) : null}
                          disabled={!defaultLangCheck}
                        />
                      </CTableDataCell>
                    </CTableRow>
                  )
                })}
              </CTableBody>
            </CTable>
          </ReactDragListView>
        </div>
        <div className="message-text error-message">{/* <p>{errorData.geoblock}</p> */}</div>
      </CCol>
    </CRow>
  )
}

export default StaticSwimlane
